import { ApiClientBase } from '../base/api-client-base.ts';
import Endpoints from '../endpoints';
import type {
  IPortfolioApi,
  AnalyzePortfolioParams,
  AnalyzePortfolioResponse,
  GetAnalysisHistoryParams,
  GetAnalysisHistoryResponse,
  GetAnalysisParams,
  GetAnalysisResponse,
  GetAnalysisStatusResponse,
} from '@/services/api';

export class PortfolioApi extends ApiClientBase implements IPortfolioApi {
  public readonly analyzePortfolio = async (
    params: AnalyzePortfolioParams
  ): Promise<AnalyzePortfolioResponse['data']> => {
    const url = Endpoints.Portfolio.analyze();
    const response = await this.asyncRunner(() =>
      this.api.post<AnalyzePortfolioResponse['data']>(url, params)
    );
    return response.data;
  };

  public readonly getAnalysisHistory = async (
    params: GetAnalysisHistoryParams
  ): Promise<GetAnalysisHistoryResponse['data']> => {
    const url = Endpoints.Portfolio.getAnalysisHistory();
    const response = await this.asyncRunner(() =>
      this.api.get<GetAnalysisHistoryResponse>(url, {params})
    );
    return response.data.data;
  };

  public readonly getAnalysis = async (
    params: GetAnalysisParams
  ): Promise<GetAnalysisResponse['data']> => {
    const url = Endpoints.Portfolio.getAnalysis(params.analysisId);
    const response = await this.asyncRunner(() =>
      this.api.get<GetAnalysisResponse['data']>(url)
    );
    return response.data;
  };

  public readonly getAnalysisStatus = async (
    params: GetAnalysisParams
  ): Promise<GetAnalysisStatusResponse['data']> => {
    const url = Endpoints.Portfolio.getAnalysisStatus(params.analysisId);
    const response = await this.asyncRunner(() =>
      this.api.get<GetAnalysisStatusResponse>(url)
    );
    return response.data.data;
  };

  public readonly getAnalysisStream = async (
    params: GetAnalysisParams
  ): Promise<ReadableStream<Uint8Array> | null> => {
    const baseURL = this.api.defaults.baseURL || '';
    const endpoint = Endpoints.Portfolio.getAnalysisStream(params.analysisId);
    const url = `${baseURL}${endpoint}`;
    const token = localStorage.getItem('auth_token');

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'text/event-stream',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch stream: ${response.statusText}`);
      }

      if (!response.body) {
        throw new Error('Response body is null');
      }

      return response.body;
    } catch (error) {
      console.error('Error fetching analysis stream:', error);
      throw error;
    }
  };
}
